import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import { Col, Container, Row } from 'react-bootstrap'
import SelectDropDown from '../component/SelectDropDown'
import RegistrationService from '../services/registration'
import InputField from '../component/InputField'
import PrimaryGradientButton from '../component/PrimaryGradientButton'
import DatePicker from '../component/DatePicker'
import OtherService from '../services/Other'
import AlertMsg from '../component/AlertMsg'
import { useNavigate } from 'react-router-dom'
import Loader from "../component/Loader";
import BasicProfileComponent from '../component/BasicProfileComponent'

const BasicRegistrationContractor = () => {

    return (
      <BasicProfileComponent/>
    )
}

export default BasicRegistrationContractor